var {
  PressResponder
} = require("@react-aria/interactions");

var {
  useOverlayTriggerState
} = require("@react-stately/overlays");

var {
  Modal,
  Popover,
  Tray
} = require("@react-spectrum/overlays");

var {
  Heading
} = require("@react-spectrum/text");

var {
  Divider
} = require("@react-spectrum/divider");

var {
  useMessageFormatter
} = require("@react-aria/i18n");

var {
  useDialog
} = require("@react-aria/dialog");

var {
  Grid
} = require("@react-spectrum/layout");

var {
  FocusScope
} = require("@react-aria/focus");

var {
  DismissButton,
  useOverlayPosition,
  useOverlayTrigger
} = require("@react-aria/overlays");

var _react2 = require("react");

var _react = $parcel$interopDefault(_react2);

var {
  useContext,
  useMemo,
  useRef,
  forwardRef,
  Fragment,
  useEffect
} = _react2;

var _spectrumIconsUiCrossLarge = $parcel$interopDefault(require("@spectrum-icons/ui/CrossLarge"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

var {
  Content
} = require("@react-spectrum/view");

var {
  classNames,
  useStyleProps,
  SlotProvider,
  unwrapDOMRef,
  useDOMRef,
  useHasChild,
  useMediaQuery
} = require("@react-spectrum/utils");

var {
  chain,
  mergeProps
} = require("@react-aria/utils");

var {
  ButtonGroup
} = require("@react-spectrum/buttongroup");

var {
  Button,
  ActionButton
} = require("@react-spectrum/button");

var _spectrumIconsUiAlertMedium = $parcel$interopDefault(require("@spectrum-icons/ui/AlertMedium"));

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

const $acaf784a76233553d69f87911a6848$export$DialogContext = /*#__PURE__*/_react.createContext(null);

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/dialog/vars.css
var $fbfe205054a1d09dba6b25d1f1121e$exports = {};
$fbfe205054a1d09dba6b25d1f1121e$exports = {
  "spectrum-Dialog": "_spectrum-Dialog_30293",
  "spectrum-Dialog--small": "_spectrum-Dialog--small_30293",
  "spectrum-Dialog--medium": "_spectrum-Dialog--medium_30293",
  "spectrum-Dialog--large": "_spectrum-Dialog--large_30293",
  "spectrum-Dialog-hero": "_spectrum-Dialog-hero_30293",
  "spectrum-Dialog-grid": "_spectrum-Dialog-grid_30293",
  "spectrum-Dialog-heading": "_spectrum-Dialog-heading_30293",
  "spectrum-Dialog-heading--noHeader": "_spectrum-Dialog-heading--noHeader_30293",
  "spectrum-Dialog-header": "_spectrum-Dialog-header_30293",
  "spectrum-Dialog-typeIcon": "_spectrum-Dialog-typeIcon_30293",
  "spectrum-Dialog-divider": "_spectrum-Dialog-divider_30293",
  "spectrum-Dialog--noDivider": "_spectrum-Dialog--noDivider_30293",
  "spectrum-Dialog-content": "_spectrum-Dialog-content_30293",
  "spectrum-Dialog-footer": "_spectrum-Dialog-footer_30293",
  "spectrum-Button": "_spectrum-Button_30293",
  "spectrum-Dialog-buttonGroup": "_spectrum-Dialog-buttonGroup_30293",
  "spectrum-Dialog-buttonGroup--noFooter": "_spectrum-Dialog-buttonGroup--noFooter_30293",
  "spectrum-Dialog--dismissable": "_spectrum-Dialog--dismissable_30293",
  "spectrum-Dialog-closeButton": "_spectrum-Dialog-closeButton_30293",
  "spectrum-Dialog--error": "_spectrum-Dialog--error_30293",
  "spectrum-Dialog--fullscreen": "_spectrum-Dialog--fullscreen_30293",
  "spectrum-Dialog--fullscreenTakeover": "_spectrum-Dialog--fullscreenTakeover_30293",
  "spectrum-Dialog--warning": "_spectrum-Dialog--warning_30293"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ar-AE.json
var $f2edaf9535940dd293a1a150d42$exports = {};
$f2edaf9535940dd293a1a150d42$exports = JSON.parse("{\"alert\":\"تنبيه\",\"dismiss\":\"تجاهل\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/bg-BG.json
var $d47657a60dce6a446561e463337d2$exports = {};
$d47657a60dce6a446561e463337d2$exports = JSON.parse("{\"alert\":\"Сигнал\",\"dismiss\":\"Отхвърляне\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/cs-CZ.json
var $aaf41d86207773bd33a13b9c2fdefae$exports = {};
$aaf41d86207773bd33a13b9c2fdefae$exports = JSON.parse("{\"alert\":\"Výstraha\",\"dismiss\":\"Odstranit\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/da-DK.json
var $fada89492396f01795b6d8b9fc048c31$exports = {};
$fada89492396f01795b6d8b9fc048c31$exports = JSON.parse("{\"alert\":\"Advarsel\",\"dismiss\":\"Luk\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/de-DE.json
var $c2039f98a7a2414febd720ea9aa4dc2f$exports = {};
$c2039f98a7a2414febd720ea9aa4dc2f$exports = JSON.parse("{\"alert\":\"Warnhinweis\",\"dismiss\":\"Schließen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/el-GR.json
var $f92c77e840e1d8faa1120faf4d27c4$exports = {};
$f92c77e840e1d8faa1120faf4d27c4$exports = JSON.parse("{\"alert\":\"Ειδοποίηση\",\"dismiss\":\"Απόρριψη\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/en-US.json
var $a56b0afce6e287db171a623c273f17$exports = {};
$a56b0afce6e287db171a623c273f17$exports = JSON.parse("{\"dismiss\":\"Dismiss\",\"alert\":\"Alert\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/es-ES.json
var $e013ca62a636e891abe4d8813d0fa63b$exports = {};
$e013ca62a636e891abe4d8813d0fa63b$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Descartar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/et-EE.json
var $d9f24cb243acc68efd43118dac82e0$exports = {};
$d9f24cb243acc68efd43118dac82e0$exports = JSON.parse("{\"alert\":\"Teade\",\"dismiss\":\"Lõpeta\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/fi-FI.json
var $aaaee9140d3768cedf8e286877d9$exports = {};
$aaaee9140d3768cedf8e286877d9$exports = JSON.parse("{\"alert\":\"Hälytys\",\"dismiss\":\"Hylkää\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/fr-FR.json
var $a432d3ac150f27a29b3c5530a1df9$exports = {};
$a432d3ac150f27a29b3c5530a1df9$exports = JSON.parse("{\"alert\":\"Alerte\",\"dismiss\":\"Rejeter\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/he-IL.json
var $a81768068b9aa62104194470cc3f0654$exports = {};
$a81768068b9aa62104194470cc3f0654$exports = JSON.parse("{\"alert\":\"התראה\",\"dismiss\":\"התעלם\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/hr-HR.json
var $e5036b5739d845cfe9f6783a407$exports = {};
$e5036b5739d845cfe9f6783a407$exports = JSON.parse("{\"alert\":\"Upozorenje\",\"dismiss\":\"Odbaci\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/hu-HU.json
var $cc5a75ca5b505e558eed9c1835f94f1e$exports = {};
$cc5a75ca5b505e558eed9c1835f94f1e$exports = JSON.parse("{\"alert\":\"Figyelmeztetés\",\"dismiss\":\"Elutasítás\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/it-IT.json
var $c4a696abd1a16f20e2b4b003fbf6fbdb$exports = {};
$c4a696abd1a16f20e2b4b003fbf6fbdb$exports = JSON.parse("{\"alert\":\"Avviso\",\"dismiss\":\"Ignora\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ja-JP.json
var $addaf646413c8be95a79f38e6345b8f2$exports = {};
$addaf646413c8be95a79f38e6345b8f2$exports = JSON.parse("{\"alert\":\"アラート\",\"dismiss\":\"閉じる\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ko-KR.json
var $e3657a3eacf72d4741ea8f0b9$exports = {};
$e3657a3eacf72d4741ea8f0b9$exports = JSON.parse("{\"alert\":\"경고\",\"dismiss\":\"무시\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/lt-LT.json
var $c51dfe5990613a5f294275b6e13ecc$exports = {};
$c51dfe5990613a5f294275b6e13ecc$exports = JSON.parse("{\"alert\":\"Įspėjimas\",\"dismiss\":\"Atmesti\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/lv-LV.json
var $ce2aae655de1b6e293ec050756a5dcb$exports = {};
$ce2aae655de1b6e293ec050756a5dcb$exports = JSON.parse("{\"alert\":\"Brīdinājums\",\"dismiss\":\"Nerādīt\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/nb-NO.json
var $f61ed65bb5df99f0804c45d92ed2ab3e$exports = {};
$f61ed65bb5df99f0804c45d92ed2ab3e$exports = JSON.parse("{\"alert\":\"Varsel\",\"dismiss\":\"Lukk\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/nl-NL.json
var $f1cfa4f0ca509c1473646b05bba816a$exports = {};
$f1cfa4f0ca509c1473646b05bba816a$exports = JSON.parse("{\"alert\":\"Melding\",\"dismiss\":\"Negeren\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/pl-PL.json
var $c3a456ea785d7b1d4b0e87a09dbcaab4$exports = {};
$c3a456ea785d7b1d4b0e87a09dbcaab4$exports = JSON.parse("{\"alert\":\"Ostrzeżenie\",\"dismiss\":\"Zignoruj\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/pt-BR.json
var $c9f6f2f98f8796205b43b84ad72b916c$exports = {};
$c9f6f2f98f8796205b43b84ad72b916c$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Descartar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/pt-PT.json
var $ddf8a9d40eed12ce095aa68902274da$exports = {};
$ddf8a9d40eed12ce095aa68902274da$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Dispensar\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ro-RO.json
var $e44701ea63d9c73bbe297bd12d650f99$exports = {};
$e44701ea63d9c73bbe297bd12d650f99$exports = JSON.parse("{\"alert\":\"Alertă\",\"dismiss\":\"Revocare\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/ru-RU.json
var $c1caed8a35bc9ad3bcb054625de80$exports = {};
$c1caed8a35bc9ad3bcb054625de80$exports = JSON.parse("{\"alert\":\"Предупреждение\",\"dismiss\":\"Пропустить\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sk-SK.json
var $d550e21bd881bd66512a8a38d56ac2af$exports = {};
$d550e21bd881bd66512a8a38d56ac2af$exports = JSON.parse("{\"alert\":\"Upozornenie\",\"dismiss\":\"Zrušiť\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sl-SI.json
var $a41b4f2e1963020b3a952fcb7469da5d$exports = {};
$a41b4f2e1963020b3a952fcb7469da5d$exports = JSON.parse("{\"alert\":\"Opozorilo\",\"dismiss\":\"Opusti\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sr-SP.json
var $b920d0a0d010e9dff65cb2996b08c573$exports = {};
$b920d0a0d010e9dff65cb2996b08c573$exports = JSON.parse("{\"alert\":\"Upozorenje\",\"dismiss\":\"Odbaci\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/sv-SE.json
var $bc2e864b27d5d33a55efa85d4c6d$exports = {};
$bc2e864b27d5d33a55efa85d4c6d$exports = JSON.parse("{\"alert\":\"Varning\",\"dismiss\":\"Avvisa\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/tr-TR.json
var $fd3766a3dabdd75be0640de4e2a917$exports = {};
$fd3766a3dabdd75be0640de4e2a917$exports = JSON.parse("{\"alert\":\"Uyarı\",\"dismiss\":\"Kapat\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/uk-UA.json
var $ff96347c2e8f1ff2c2f9ebfa4c1f3$exports = {};
$ff96347c2e8f1ff2c2f9ebfa4c1f3$exports = JSON.parse("{\"alert\":\"Сигнал тривоги\",\"dismiss\":\"Скасувати\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/zh-CN.json
var $f24d62a73ef94c1435318b9f95e0e1$exports = {};
$f24d62a73ef94c1435318b9f95e0e1$exports = JSON.parse("{\"alert\":\"警报\",\"dismiss\":\"取消\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/dialog/intl/zh-TW.json
var $a102752d8d7f8dcfc276715c9d290294$exports = {};
$a102752d8d7f8dcfc276715c9d290294$exports = JSON.parse("{\"alert\":\"警示\",\"dismiss\":\"關閉\"}");
// @ts-ignore
const $c24df1e30ea6d5a25486b1eedd756cd$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($f2edaf9535940dd293a1a150d42$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($d47657a60dce6a446561e463337d2$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($aaf41d86207773bd33a13b9c2fdefae$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($fada89492396f01795b6d8b9fc048c31$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($c2039f98a7a2414febd720ea9aa4dc2f$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($f92c77e840e1d8faa1120faf4d27c4$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($a56b0afce6e287db171a623c273f17$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($e013ca62a636e891abe4d8813d0fa63b$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($d9f24cb243acc68efd43118dac82e0$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($aaaee9140d3768cedf8e286877d9$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($a432d3ac150f27a29b3c5530a1df9$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($a81768068b9aa62104194470cc3f0654$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($e5036b5739d845cfe9f6783a407$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($cc5a75ca5b505e558eed9c1835f94f1e$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($c4a696abd1a16f20e2b4b003fbf6fbdb$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($addaf646413c8be95a79f38e6345b8f2$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($e3657a3eacf72d4741ea8f0b9$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($c51dfe5990613a5f294275b6e13ecc$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($ce2aae655de1b6e293ec050756a5dcb$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($f61ed65bb5df99f0804c45d92ed2ab3e$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($f1cfa4f0ca509c1473646b05bba816a$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($c3a456ea785d7b1d4b0e87a09dbcaab4$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($c9f6f2f98f8796205b43b84ad72b916c$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($ddf8a9d40eed12ce095aa68902274da$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($e44701ea63d9c73bbe297bd12d650f99$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($c1caed8a35bc9ad3bcb054625de80$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($d550e21bd881bd66512a8a38d56ac2af$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($a41b4f2e1963020b3a952fcb7469da5d$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($b920d0a0d010e9dff65cb2996b08c573$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($bc2e864b27d5d33a55efa85d4c6d$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($fd3766a3dabdd75be0640de4e2a917$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($ff96347c2e8f1ff2c2f9ebfa4c1f3$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($f24d62a73ef94c1435318b9f95e0e1$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($a102752d8d7f8dcfc276715c9d290294$exports).default
};
let $c24df1e30ea6d5a25486b1eedd756cd$var$sizeMap = {
  S: 'small',
  M: 'medium',
  L: 'large',
  fullscreen: 'fullscreen',
  fullscreenTakeover: 'fullscreenTakeover'
};
var $fbfe205054a1d09dba6b25d1f1121e$$interop$default = $parcel$interopDefault($fbfe205054a1d09dba6b25d1f1121e$exports);

function $c24df1e30ea6d5a25486b1eedd756cd$var$Dialog(props, ref) {
  let _ref = useContext($acaf784a76233553d69f87911a6848$export$DialogContext) || {},
      {
    type = 'modal'
  } = _ref,
      contextProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(_ref, ["type"]);

  let {
    children,
    isDismissable = contextProps.isDismissable,
    onDismiss = contextProps.onClose,
    size
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["children", "isDismissable", "onDismiss", "size"]);

  let formatMessage = useMessageFormatter($c24df1e30ea6d5a25486b1eedd756cd$var$intlMessages);
  let {
    styleProps
  } = useStyleProps(otherProps);
  size = type === 'popover' ? size || 'S' : size || 'L';
  let domRef = useDOMRef(ref);
  let gridRef = useRef();
  let sizeVariant = $c24df1e30ea6d5a25486b1eedd756cd$var$sizeMap[type] || $c24df1e30ea6d5a25486b1eedd756cd$var$sizeMap[size];
  let {
    dialogProps,
    titleProps
  } = useDialog(mergeProps(contextProps, props), domRef);
  let hasHeader = useHasChild("." + $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-header'], unwrapDOMRef(gridRef));
  let hasFooter = useHasChild("." + $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-footer'], unwrapDOMRef(gridRef));
  let slots = useMemo(() => ({
    hero: {
      UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-hero']
    },
    header: {
      UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-header']
    },
    heading: _babelRuntimeHelpersExtends({
      UNSAFE_className: classNames($fbfe205054a1d09dba6b25d1f1121e$$interop$default, 'spectrum-Dialog-heading', {
        'spectrum-Dialog-heading--noHeader': !hasHeader
      })
    }, titleProps),
    typeIcon: {
      UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-typeIcon']
    },
    divider: {
      UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-divider'],
      size: 'M'
    },
    content: {
      UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-content']
    },
    footer: {
      UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-footer']
    },
    buttonGroup: {
      UNSAFE_className: classNames($fbfe205054a1d09dba6b25d1f1121e$$interop$default, 'spectrum-Dialog-buttonGroup', {
        'spectrum-Dialog-buttonGroup--noFooter': !hasFooter
      }),
      align: 'end'
    }
  }), [$fbfe205054a1d09dba6b25d1f1121e$$interop$default, hasFooter, hasHeader, titleProps]); // If rendered in a popover or tray there won't be a visible dismiss button,
  // so we render a hidden one for screen readers.

  let dismissButton;

  if (type === 'popover' || type === 'tray') {
    dismissButton = /*#__PURE__*/_react.createElement(DismissButton, {
      onDismiss: onDismiss
    });
  }

  return /*#__PURE__*/_react.createElement(FocusScope, {
    contain: true,
    restoreFocus: true
  }, /*#__PURE__*/_react.createElement("section", _babelRuntimeHelpersExtends({}, styleProps, dialogProps, {
    className: classNames($fbfe205054a1d09dba6b25d1f1121e$$interop$default, 'spectrum-Dialog', {
      ["spectrum-Dialog--" + sizeVariant]: sizeVariant,
      'spectrum-Dialog--dismissable': isDismissable
    }, styleProps.className),
    ref: domRef
  }), /*#__PURE__*/_react.createElement(Grid, {
    ref: gridRef,
    UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-grid']
  }, /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: slots
  }, children), isDismissable && /*#__PURE__*/_react.createElement(ActionButton, {
    UNSAFE_className: $fbfe205054a1d09dba6b25d1f1121e$$interop$default['spectrum-Dialog-closeButton'],
    isQuiet: true,
    "aria-label": formatMessage('dismiss'),
    onPress: onDismiss
  }, /*#__PURE__*/_react.createElement(_spectrumIconsUiCrossLarge, null))), dismissButton));
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */


let Dialog = /*#__PURE__*/_react.forwardRef($c24df1e30ea6d5a25486b1eedd756cd$var$Dialog);

exports.Dialog = Dialog;
// @ts-ignore
const $eab8b93d67846b9c7317cd8c3302e$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($f2edaf9535940dd293a1a150d42$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($d47657a60dce6a446561e463337d2$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($aaf41d86207773bd33a13b9c2fdefae$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($fada89492396f01795b6d8b9fc048c31$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($c2039f98a7a2414febd720ea9aa4dc2f$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($f92c77e840e1d8faa1120faf4d27c4$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($a56b0afce6e287db171a623c273f17$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($e013ca62a636e891abe4d8813d0fa63b$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($d9f24cb243acc68efd43118dac82e0$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($aaaee9140d3768cedf8e286877d9$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($a432d3ac150f27a29b3c5530a1df9$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($a81768068b9aa62104194470cc3f0654$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($e5036b5739d845cfe9f6783a407$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($cc5a75ca5b505e558eed9c1835f94f1e$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($c4a696abd1a16f20e2b4b003fbf6fbdb$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($addaf646413c8be95a79f38e6345b8f2$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($e3657a3eacf72d4741ea8f0b9$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($c51dfe5990613a5f294275b6e13ecc$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($ce2aae655de1b6e293ec050756a5dcb$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($f61ed65bb5df99f0804c45d92ed2ab3e$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($f1cfa4f0ca509c1473646b05bba816a$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($c3a456ea785d7b1d4b0e87a09dbcaab4$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($c9f6f2f98f8796205b43b84ad72b916c$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($ddf8a9d40eed12ce095aa68902274da$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($e44701ea63d9c73bbe297bd12d650f99$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($c1caed8a35bc9ad3bcb054625de80$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($d550e21bd881bd66512a8a38d56ac2af$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($a41b4f2e1963020b3a952fcb7469da5d$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($b920d0a0d010e9dff65cb2996b08c573$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($bc2e864b27d5d33a55efa85d4c6d$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($fd3766a3dabdd75be0640de4e2a917$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($ff96347c2e8f1ff2c2f9ebfa4c1f3$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($f24d62a73ef94c1435318b9f95e0e1$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($a102752d8d7f8dcfc276715c9d290294$exports).default
};

/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */
function $eab8b93d67846b9c7317cd8c3302e$var$AlertDialog(props, ref) {
  let {
    onClose = () => {}
  } = useContext($acaf784a76233553d69f87911a6848$export$DialogContext) || {};

  let {
    variant,
    children,
    primaryActionLabel,
    secondaryActionLabel,
    cancelLabel,
    autoFocusButton,
    title,
    isPrimaryActionDisabled,
    isSecondaryActionDisabled,
    onCancel = () => {},
    onPrimaryAction = () => {},
    onSecondaryAction = () => {}
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["variant", "children", "primaryActionLabel", "secondaryActionLabel", "cancelLabel", "autoFocusButton", "title", "isPrimaryActionDisabled", "isSecondaryActionDisabled", "onCancel", "onPrimaryAction", "onSecondaryAction"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let formatMessage = useMessageFormatter($eab8b93d67846b9c7317cd8c3302e$var$intlMessages);
  let confirmVariant = 'primary';

  if (variant) {
    if (variant === 'confirmation') {
      confirmVariant = 'cta';
    } else if (variant === 'destructive') {
      confirmVariant = 'negative';
    }
  }

  return /*#__PURE__*/_react.createElement(Dialog, {
    UNSAFE_style: styleProps.style,
    UNSAFE_className: classNames($fbfe205054a1d09dba6b25d1f1121e$$interop$default, {
      ["spectrum-Dialog--" + variant]: variant
    }, styleProps.className),
    isHidden: styleProps.hidden,
    size: "M",
    role: "alertdialog",
    ref: ref
  }, /*#__PURE__*/_react.createElement(Heading, null, title), (variant === 'error' || variant === 'warning') && /*#__PURE__*/_react.createElement(_spectrumIconsUiAlertMedium, {
    slot: "typeIcon",
    "aria-label": formatMessage('alert')
  }), /*#__PURE__*/_react.createElement(Divider, null), /*#__PURE__*/_react.createElement(Content, null, children), /*#__PURE__*/_react.createElement(ButtonGroup, {
    align: "end"
  }, cancelLabel && /*#__PURE__*/_react.createElement(Button, {
    variant: "secondary",
    onPress: () => chain(onClose(), onCancel()),
    autoFocus: autoFocusButton === 'cancel'
  }, cancelLabel), secondaryActionLabel && /*#__PURE__*/_react.createElement(Button, {
    variant: "secondary",
    onPress: () => chain(onClose(), onSecondaryAction()),
    isDisabled: isSecondaryActionDisabled,
    autoFocus: autoFocusButton === 'secondary'
  }, secondaryActionLabel), /*#__PURE__*/_react.createElement(Button, {
    variant: confirmVariant,
    onPress: () => chain(onClose(), onPrimaryAction()),
    isDisabled: isPrimaryActionDisabled,
    autoFocus: autoFocusButton === 'primary'
  }, primaryActionLabel)));
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */


let AlertDialog = /*#__PURE__*/forwardRef($eab8b93d67846b9c7317cd8c3302e$var$AlertDialog);
exports.AlertDialog = AlertDialog;

function $e8eede229dc4bb152d31b6896bc207be$var$DialogTrigger(props) {
  let {
    children,
    type = 'modal',
    mobileType = type === 'popover' ? 'modal' : type,
    hideArrow,
    targetRef,
    isDismissable,
    isKeyboardDismissDisabled
  } = props,
      positionProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["children", "type", "mobileType", "hideArrow", "targetRef", "isDismissable", "isKeyboardDismissDisabled"]);

  if (!Array.isArray(children) || children.length > 2) {
    throw new Error('DialogTrigger must have exactly 2 children');
  } // if a function is passed as the second child, it won't appear in toArray


  let [trigger, content] = children; // On small devices, show a modal or tray instead of a popover.
  // TODO: DNA variable?

  let isMobile = useMediaQuery('(max-width: 700px)');

  if (isMobile) {
    // handle cases where desktop popovers need a close button for the mobile modal view
    if (type !== 'modal' && mobileType === 'modal') {
      isDismissable = true;
    }

    type = mobileType;
  }

  let state = useOverlayTriggerState(props);
  let wasOpen = useRef(false);
  wasOpen.current = state.isOpen;
  let isExiting = useRef(false);

  let onExiting = () => isExiting.current = true;

  let onExited = () => isExiting.current = false; // eslint-disable-next-line arrow-body-style


  useEffect(() => {
    return () => {
      if ((wasOpen.current || isExiting.current) && type !== 'popover' && type !== 'tray') {
        console.warn('A DialogTrigger unmounted while open. This is likely due to being placed within a trigger that unmounts or inside a conditional. Consider using a DialogContainer instead.');
      }
    };
  }, []);

  if (type === 'popover') {
    return /*#__PURE__*/_react.createElement($e8eede229dc4bb152d31b6896bc207be$var$PopoverTrigger, _babelRuntimeHelpersExtends({}, positionProps, {
      state: state,
      targetRef: targetRef,
      trigger: trigger,
      content: content,
      isKeyboardDismissDisabled: isKeyboardDismissDisabled,
      hideArrow: hideArrow
    }));
  }

  let renderOverlay = () => {
    switch (type) {
      case 'fullscreen':
      case 'fullscreenTakeover':
      case 'modal':
        return /*#__PURE__*/_react.createElement(Modal, {
          isOpen: state.isOpen,
          isDismissable: type === 'modal' ? isDismissable : false,
          onClose: state.close,
          type: type,
          isKeyboardDismissDisabled: isKeyboardDismissDisabled,
          onExiting: onExiting,
          onExited: onExited
        }, typeof content === 'function' ? content(state.close) : content);

      case 'tray':
        return /*#__PURE__*/_react.createElement(Tray, {
          isOpen: state.isOpen,
          onClose: state.close,
          isKeyboardDismissDisabled: isKeyboardDismissDisabled
        }, typeof content === 'function' ? content(state.close) : content);
    }
  };

  return /*#__PURE__*/_react.createElement($e8eede229dc4bb152d31b6896bc207be$var$DialogTriggerBase, {
    type: type,
    state: state,
    isDismissable: isDismissable,
    trigger: trigger,
    overlay: renderOverlay()
  });
} // Support DialogTrigger inside components using CollectionBuilder.


$e8eede229dc4bb152d31b6896bc207be$var$DialogTrigger.getCollectionNode = function* (props) {
  let [trigger] = _react.Children.toArray(props.children);

  let [, content] = props.children;
  yield {
    element: trigger,
    wrapper: element => /*#__PURE__*/_react.createElement($e8eede229dc4bb152d31b6896bc207be$var$DialogTrigger, _babelRuntimeHelpersExtends({
      key: element.key
    }, props), element, content)
  };
};
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */
// We don't want getCollectionNode to show up in the type definition


let DialogTrigger = $e8eede229dc4bb152d31b6896bc207be$var$DialogTrigger;
exports.DialogTrigger = DialogTrigger;

function $e8eede229dc4bb152d31b6896bc207be$var$PopoverTrigger(_ref) {
  let {
    state,
    targetRef,
    trigger,
    content,
    hideArrow,
    isKeyboardDismissDisabled
  } = _ref,
      props = _babelRuntimeHelpersObjectWithoutPropertiesLoose(_ref, ["state", "targetRef", "trigger", "content", "hideArrow", "isKeyboardDismissDisabled"]);

  let triggerRef = useRef();
  let overlayRef = useRef();
  let {
    overlayProps: popoverProps,
    placement,
    arrowProps
  } = useOverlayPosition({
    targetRef: targetRef || triggerRef,
    overlayRef: unwrapDOMRef(overlayRef),
    placement: props.placement,
    containerPadding: props.containerPadding,
    offset: props.offset,
    crossOffset: props.crossOffset,
    shouldFlip: props.shouldFlip,
    isOpen: state.isOpen
  });
  let {
    triggerProps,
    overlayProps
  } = useOverlayTrigger({
    type: 'dialog'
  }, state, triggerRef);

  let triggerPropsWithRef = _babelRuntimeHelpersExtends({}, triggerProps, {
    ref: targetRef ? undefined : triggerRef
  });

  let overlay = /*#__PURE__*/_react.createElement(Popover, {
    isOpen: state.isOpen,
    UNSAFE_style: popoverProps.style,
    ref: overlayRef,
    onClose: state.close,
    placement: placement,
    arrowProps: arrowProps,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    hideArrow: hideArrow
  }, typeof content === 'function' ? content(state.close) : content);

  return /*#__PURE__*/_react.createElement($e8eede229dc4bb152d31b6896bc207be$var$DialogTriggerBase, {
    type: "popover",
    state: state,
    triggerProps: triggerPropsWithRef,
    dialogProps: overlayProps,
    trigger: trigger,
    overlay: overlay
  });
}

function $e8eede229dc4bb152d31b6896bc207be$var$DialogTriggerBase(_ref2) {
  let {
    type,
    state,
    isDismissable,
    dialogProps = {},
    triggerProps = {},
    overlay,
    trigger
  } = _ref2;

  let context = _babelRuntimeHelpersExtends({
    type,
    onClose: state.close,
    isDismissable
  }, dialogProps);

  return /*#__PURE__*/_react.createElement(Fragment, null, /*#__PURE__*/_react.createElement(PressResponder, _babelRuntimeHelpersExtends({}, triggerProps, {
    onPress: state.toggle,
    isPressed: state.isOpen && type !== 'modal' && type !== 'fullscreen' && type !== 'fullscreenTakeover'
  }), trigger), /*#__PURE__*/_react.createElement($acaf784a76233553d69f87911a6848$export$DialogContext.Provider, {
    value: context
  }, overlay));
}

/**
 * A DialogContainer accepts a single Dialog as a child, and manages showing and hiding
 * it in a modal. Useful in cases where there is no trigger element
 * or when the trigger unmounts while the dialog is open.
 */
function DialogContainer(props) {
  let {
    children,
    type = 'modal',
    onDismiss,
    isDismissable,
    isKeyboardDismissDisabled
  } = props;

  let childArray = _react.Children.toArray(children);

  if (childArray.length > 1) {
    throw new Error('Only a single child can be passed to DialogContainer.');
  }

  let lastChild = useRef(null);
  let child = /*#__PURE__*/_react.isValidElement(childArray[0]) ? childArray[0] : null;

  if (child) {
    lastChild.current = child;
  }

  let context = {
    type,
    onClose: onDismiss,
    isDismissable
  };
  return /*#__PURE__*/_react.createElement(Modal, {
    isOpen: !!child,
    onClose: onDismiss,
    type: type,
    isDismissable: isDismissable,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled
  }, /*#__PURE__*/_react.createElement($acaf784a76233553d69f87911a6848$export$DialogContext.Provider, {
    value: context
  }, lastChild.current));
}

exports.DialogContainer = DialogContainer;

function useDialogContainer() {
  let context = useContext($acaf784a76233553d69f87911a6848$export$DialogContext);

  if (!context) {
    throw new Error('Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.');
  }

  return {
    type: context.type,

    dismiss() {
      context.onClose();
    }

  };
}

exports.useDialogContainer = useDialogContainer;
